import React, { FC } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
// import { Checkbox } from "@mui/material";
import { Column } from "../../../../interfaces/table";
import { Tooltip } from "@mui/material";

interface IRow {
  row: any;
  isItemSelected: boolean;
  columns: Column[];
  index: number;
  handleItemClick?: (event: React.MouseEvent<unknown>, id: number) => void;
  onRowClick?: (data: any) => void;
  isDraggable?: boolean;
}
const Rows: FC<IRow> = ({
  row,
  isItemSelected,
  index,
  handleItemClick,
  columns,
  onRowClick,
  isDraggable = false,
}) => {
  // const labelId = `enhanced-table-checkbox-${index}`;
  return (
    <React.Fragment>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        className={`${onRowClick && "cursor-pointer"} `}
        hover={true}
      >
        {/* commented for now as we dont have requirement for checkbox selection */}
       {isDraggable && <TableCell
        className="!border-y-0" padding="checkbox">
          <div className="flex items-center  border-y-0 border-r-[1px] border-[#EAEAEA] h-[65px]">
            <img src="/images/compImages/dragIcon.svg" alt="icon" />
          </div>
        </TableCell>}

        {columns.map((item) => (
          <TableCell
            sx={{ borderRight: "1px solid #EAEAEA" }}
            align={item.align}
            style={{ minWidth: item.minWidth }}
            className=""
            key={item.id}
            onClick={() => {
              if (item.id === "link") {
              } else if (onRowClick && item.id !== "actions") onRowClick(row);
            }}
          >
            <Tooltip
              title={item?.render ? null : row[item.key]}
              className={`${
                item.key === "slug" ? "" : "capitalize"
              } line-clamp-3 text-wrap break-words`}
            >
              {item?.render ? (
                item?.render(
                  row?.[item?.key] ? row[item.key] : null,
                  row,
                  index
                )
              ) : row?.[item?.key] ? (
                item?.key === "link" ? (
                  <a
                    rel="noreferrer"
                    className="text-blue-400 underline"
                    target="_blank"
                    href={row[item.key]}
                  >
                    Click here
                  </a>
                ) : (
                  row[item.key]
                )
              ) : (
                "-"
              )}
            </Tooltip>
          </TableCell>
        ))}
      </TableRow>
    </React.Fragment>
  );
};

export default Rows;
